var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenDisputeAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88.237,
    height: 93.852,
    viewBox: "0 0 88.237 93.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_94249",
    x: 0,
    y: 0,
    width: 88.237,
    height: 93.852,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47836",
    "data-name": "Group 47836",
    transform: "translate(7849.875 19208.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Uploader",
    transform: "translate(-7841 -19201)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.88, -7.48)",
    filter: "url(#Path_94249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94249-2",
    "data-name": "Path 94249",
    d: "M3.509,0h57.22c1.938,0,3.509,2.51,3.509,5.605V64.246c0,3.1-1.571,5.605-3.509,5.605H3.509C1.571,69.852,0,67.342,0,64.246V5.605C0,2.51,1.571,0,3.509,0Z",
    transform: "translate(12 12)",
    fill: "#a1a3ef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(7.957 22.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M28.6,9.411c0-.093.016-.186.016-.28A9.019,9.019,0,0,0,11.431,5.2,4.64,4.64,0,0,0,4.743,8.619a7.069,7.069,0,0,0,2.25,13.744H15V16.152H11.236l6.266-6.5,6.266,6.492H20v6.212h8.618A6.473,6.473,0,0,0,28.6,9.411Z",
    transform: "translate(9.785 6.252)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDisputeAttach);
export default __webpack_public_path__ + "static/media/OpenDisputeAttach.f481a562b5dd97e6a460c1ac8ecd008b.svg";
export { ForwardRef as ReactComponent };